// form表单文字宽度
export const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 17 },
}
// 保存按钮宽度
export const wrapperCol = {
    span: 17,
    offset: 6
}
// 弹框宽度
export const drawerWidth = 750

// base64转化为文件
export const base64ToFile = (base64, filename, mimeType) => {
    const byteCharacters = atob(base64.replace(/^data:.*?;base64,/, ''))
    const byteNumbers = new Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)

    return new File([byteArray], filename, { type: mimeType })
}

// 文件转为base64
export const fileToBase64 = (file) => {
    let blob = new Blob([file, { type: file.type }])
    return new Promise((resolve, reject) => {
        // 创建一个新的 FileReader 对象
        const reader = new FileReader();
        // 读取 File 对象
        reader.readAsDataURL(blob);
        // 加载完成后
        reader.onload = function () {
            // 将读取的数据转换为 base64 编码的字符串
            const base64String = reader.result.split(",")[1];
            // 解析为 Promise 对象，并返回 base64 编码的字符串
            resolve(base64String);
        };
    
        // 加载失败时
        reader.onerror = function () {
            reject(new Error("Failed to load file"));
        };
    });
}